<template>
  <div>
    <b-modal id="modalImportXml" size="xl" title="" @hide="cancel" centered>
      <template #modal-title>
        <div class="headerModal">
          <div style="display: flex; align-items: center; gap: 10px">
            <div class="contentIconHeader">
              <b-icon-folder-symlink
                style="width: 18px; height: 18px; color: #006256"
              />
            </div>

            <div>
              <span style="font-family: Poppins-Bold, sans-serif !important"
                >Importação de XML</span
              >

              <p
                v-if="!productsListGrid.length"
                class="m-0"
                style="
                  font-size: 0.6rem;
                  color: rgb(111, 111, 111);
                  font-weight: 500 !important;
                "
              >
                PASSO 1: SELEÇÃO DE ARQUIVO
              </p>

              <p
                v-else
                class="m-0"
                style="
                  font-size: 0.6rem;
                  color: rgb(111, 111, 111);
                  font-weight: 500 !important;
                "
              >
                PASSO 2: MAPEAMENTO DE ITENS
              </p>
            </div>
          </div>
        </div>
      </template>
      <div>
        <b-row class="inputXml" v-show="!productsListGrid.length">
          <AttachXmlFile ref="attachedFile" :isClear="isClear" />

          <b-button
            class="linkXml"
            :disabled="isLoading"
            @click="converXmlAndReturnObjectAndSave"
            >Ler Xml <b-spinner class="spin" v-if="this.isLoading" />
          </b-button>
        </b-row>

        <div
          style="display: flex; flex-direction: column; gap: 1rem"
          v-if="productsListGrid.length"
        >
          <div
            style="border: solid 1px rgb(226 232 240 / 1); border-radius: 8px"
          >
            <table class="tableItems">
              <thead>
                <tr>
                  <th>#</th>
                  <th>PRODUTO (XML)</th>
                  <th style="text-align: center">QNT. ESTOQUE</th>
                  <th>VALOR (UNIT / TOTAL)</th>
                  <th>PRODUTO EXISTENTE</th>
                  <th>CFOP</th>
                  <th style="text-align: center">AGROTÓXICO ?</th>
                  <th>AÇÕES</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, idx) in productsListGrid" :key="idx">
                  <td style="text-align: center; color: rgb(159 159 159)">
                    {{ idx + 1 }}
                  </td>

                  <td
                    style="
                      font-family: Poppins-Medium, sans-serif !important;
                      font-weight: 500 !important;
                      color: black;
                      font-size: 11px;
                      width: 25%;
                    "
                  >
                    {{ item.nome }}
                  </td>

                  <td class="quantityColumn">
                    <b-form-input
                      :value="item.quantidade"
                      type="number"
                      min="0.00001"
                      step="any"
                      class="quantityInput"
                      :state="isValidQuantity(item.quantidade) ? null : false"
                      @input="handleQuantityChange($event, idx)"
                    />
                    <small class="xmlQuantity">
                      XML: {{ getXmlQuantity(idx) }}
                    </small>
                  </td>

                  <td style="width: 15%">
                    <div>
                      <p
                        class="m-0"
                        style="
                          font-family: Poppins-Medium, sans-serif !important;
                          font-weight: 500 !important;
                          color: black;
                          font-size: 11px;
                        "
                      >
                        {{
                          item.valorUnitario.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </p>

                      <p
                        class="m-0"
                        style="
                          font-family: Poppins-Medium, sans-serif !important;
                          font-weight: 500 !important;
                          font-size: 9.5px;
                          color: rgb(111, 111, 111);
                        "
                      >
                        Total:
                        {{
                          (item.valorUnitario * item.quantidade).toLocaleString(
                            "pt-br",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )
                        }}
                      </p>
                    </div>
                  </td>

                  <td style="width: 30%">
                    <div
                      style="display: flex; flex-direction: column; gap: 0.8rem"
                    >
                      <div
                        class="selectPlus"
                        style="width: 100%"
                        v-if="isAgrotoxico[idx] === 'agrotoxico'"
                      >
                        <InputProducts
                          :key="`agro-${idx}-${
                            productRefreshVersions[idx] || 0
                          }`"
                          label="Agrotóxicos"
                          typeFilter="itens"
                          :isEdit="idProductForSelectBox[idx]"
                          :dataInput.sync="idProductForSelectBox[idx]"
                          :isDisabled="isProductLinked(item)"
                          :onSearch="fillPesticidesComboBoxWithPaginate"
                          :enableIconCreate="false"
                          :filterIsEnable="false"
                          :showLabel="false"
                          @selectItem="handleSelectItem($event, idx)"
                          searchFields="nomeComum"
                          noPadding
                        />
                      </div>

                      <div class="selectPlus" style="width: 90%" v-else>
                        <span
                          v-if="
                            idProductForSelectBox[idx] &&
                            productStocks[idx] != null
                          "
                          class="currentProductStock"
                        >
                          Estoque Atual: {{ productStocks[idx] }}
                        </span>

                        <InputInfinit
                          :key="`prod-${idx}-${
                            productRefreshVersions[idx] || 0
                          }`"
                          label="Produto"
                          typeFilter="itens"
                          :isEdit="idProductForSelectBox[idx]"
                          :dataInput="idProductForSelectBox[idx]"
                          :isDisabled="isProductLinked(item)"
                          @update:dataInput="
                            $set(idProductForSelectBox, idx, $event)
                          "
                          :onSearch="fillProductsComboBoxWithPaginate"
                          :openCreateModal="
                            () =>
                              handleModalCreateProduct(
                                'modalCreateProduct',
                                idProductForSelectBox[idx],
                                idx
                              )
                          "
                          :searchFields="['nome', 'codRef']"
                          :showLabel="false"
                          :filterIsEnable="false"
                          @selectItem="handleSelectProduct($event, idx)"
                          noPadding
                        />
                      </div>

                      <div
                        style="display: flex; gap: 0.5rem"
                        v-if="isAgrotoxico[idx] === 'agrotoxico'"
                      >
                        <InputSelect
                          style="width: 60%"
                          label="Embalagens"
                          valueField="id"
                          textField="descricao"
                          :items="listEmbs[idx]"
                          :enableIconCreate="false"
                          @selectedIten="handleSelectEmb($event, idx)"
                          :isDisabled="
                            !idProductForSelectBox[idx] || isProductLinked(item)
                          "
                        />

                        <div class="selectPlus" style="width: 40%">
                          <b-form-input
                            class="borderInput shadow-none"
                            :list="`lista-de-lotes-${idx}`"
                            autocomplete="off"
                            placeholder="lotes"
                            v-model="selectedPesticides[idx].lote"
                            :disabled="
                              !selectedPesticides[idx].idEmb ||
                              isProductLinked(item)
                            "
                          ></b-form-input>

                          <b-form-datalist
                            :id="`lista-de-lotes-${idx}`"
                            text-field="lote"
                            value-field="lote"
                            :options="dataLotes"
                          ></b-form-datalist>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td class="cfopColumn">
                    <b-form-select
                      class="borderInput shadow-none"
                      text-field="text"
                      value-field="value"
                      v-model="objectPurchaseTotal.products[idx].cfop"
                      size="sm"
                      :options="getCfopOptions(objectPurchaseTotal.products[idx].cfop)"
                    >
                      <template #first>
                        <b-form-select-option value="" disabled>
                          Selecione
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>

                  <td style="width: 10%">
                    <div
                      style="display: flex; flex-direction: column; gap: 0.5rem"
                    >
                      <div class="itemToggleDesc">
                        <label
                          class="switch col-sm-2 col-md-2 col-lg-2 col-xl-2"
                        >
                          <input
                            type="checkbox"
                            ref="typeDiscount"
                            true-value="agrotoxico"
                            false-value="normal"
                            v-model="isAgrotoxico[idx]"
                            @change="changeTypeProduct(idx)"
                            :disabled="isProductLinked(item)"
                          />

                          <div class="slider"></div>
                        </label>
                      </div>
                    </div>
                  </td>

                  <td>
                    <b-button
                      v-if="!isProductLinked(item)"
                      :disabled="!idProductForSelectBox[idx]"
                      style="width: 100%"
                      class="linkProduct"
                      @click="
                        assingProducts(item, idx, idProductForSelectBox[idx])
                      "
                      >Vincular</b-button
                    >
                    <b-button
                      v-else
                      style="width: 100%"
                      class="unlinkProduct"
                      @click="unlinkProduct(idx)"
                      >Desvincular</b-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            style="
              border: solid 1px rgb(226 232 240 / 1);
              border-radius: 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 14px;
            "
          >
            <div style="display: flex; align-items: center; gap: 0.5rem">
              <div>
                <p
                  class="m-0"
                  style="
                    font-family: Poppins-Bold, sans-serif !important;
                    color: rgb(111, 111, 111);
                    font-size: 9px;
                  "
                >
                  TOTAL XML
                </p>
                <p
                  class="m-0"
                  style="
                    font-family: Poppins-Bold, sans-serif !important;
                    color: black;
                    font-size: 14px;
                  "
                >
                  {{
                    this.objectPurchaseTotal.purchase.valorNfe.toLocaleString(
                      "pt-br",
                      { style: "currency", currency: "BRL" }
                    )
                  }}
                </p>
              </div>

              <hr
                style="
                  height: 100%;
                  margin: 1rem;
                  width: 1px;
                  background-color: rgb(226 232 240 / 1);
                "
              />

              <div>
                <p
                  class="m-0"
                  style="
                    font-family: Poppins-Bold, sans-serif !important;
                    color: rgb(111, 111, 111);
                    font-size: 9px;
                  "
                >
                  ITENS MAPEADOS
                </p>

                <p
                  class="m-0"
                  style="
                    font-family: Poppins-Bold, sans-serif !important;
                    color: #00786a;
                    font-size: 14px;
                  "
                >
                  {{ getMappedItems }} / {{ productsListGrid.length }}
                </p>
              </div>
            </div>

            <div
              style="
                display: flex;
                align-items: center;
                gap: 0.3rem;
                padding: 7px 14px;
                background-color: #f1f1f1;
                border-radius: 10px;
                text-align: center;
                color: rgb(111, 111, 111);
                background-color: #c1c1c120;
                font-family: Poppins-Medium, sans-serif !important;
                font-weight: 500 !important;
                font-size: 9.5px;
              "
            >
              <b-icon-patch-exclamation-fill scale="1.3" />

              <p class="m-0">
                Dica: Vincule itens para adicioná-los a um estoque de item já
                existente.
              </p>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div v-if="productsListGrid.length">
            <b-button class="goBackBtn" @click="goBack">Voltar</b-button>
          </div>

          <div class="content-btn">
            <b-button @click="$bvModal.hide('modalImportXml')" class="CancelBtn"
              >Cancelar</b-button
            >

            <div
              class="saveBtn"
              style="gap: 10px"
              v-if="isLoading && productsListGrid.length"
            >
              <b-spinner class="spin" style="color: green" />
              <span>Aguarde ...</span>
            </div>

            <b-button
              v-else-if="!isLoading && productsListGrid.length"
              @click="saveAllPurchase"
              class="saveBtn"
              >Salvar produtos
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <!-- <b-modal id="modal-center3" hide-footer hide-header centered title="assign">
      <div class="contentNot">
        <div class="contentNot">
          <img class="alertImg" :src="alert" />
          <span>Já existe uma nota importada com essa chave</span>
          <span>Deseja prosseguir ?</span>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="assignValuesToTheObjectPurchase">
            Continuar
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center3')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal> -->

    <b-modal id="modal-bill" hide-footer hide-header centered title="bill">
      <div class="contentNot">
        <div class="contentNot">
          <img class="alertImg" :src="alert" />
          <span>Deseja Realizar o lançamento dessa conta ?</span>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="generateDuplicate">
            Ir para o Financeiro
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-bill')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>

    <ModalCreateProducts
      @getAllNewProduct="handleCreatedNewProduct"
      :idProductFromSearch="idProductFromSearch"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { v4 as uuidv4 } from "uuid";

import AttachXmlFile from "../AttachFiles/AttachXmlFile.vue";
import InputInfinit from "../UI/CustomInputs/InputInfinit.vue";
import InputProducts from "../UI/CustomInputs/InputProducts.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";

import ModalCreateProducts from "../Modals/ModalCreateProduct.vue";

import api from "../../services/axios";
import ConvertXml from "../../services/serviceConvertXml";
import AssigningValuesToTheObject from "../../services/assigningValues​ToTheObject";
import ServiceImportMovimentPurchase from "../../services/serviceImportMovimentPurchase";
import ServiceProducts from "../../services/serviceProducts";
import ServiceDfe from "../../services/serviceDfe";
import ServiceCompendio from "../../services/serviceCompendio";

import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import { removeReference } from "../../utils/removeReference";
import { cfop } from "../../common/index";

import alert from "../../assets/alert.svg";

export default {
  props: {
    cfopSelect: {
      type: String,
    },
    payloadFromDfe: {
      type: Object,
    },
  },
  data() {
    return {
      alert: alert,
      objectPurchaseTotal: {},
      productsListGrid: [],
      originalXmlProducts: [],
      originalProductTotals: [],
      originalProductQuantities: [],
      productsForSelectBox: [],
      idProductForSelectBox: [],
      isAgrotoxico: [],
      listEmbs: [],
      dataLotes: [],
      selectedPesticides: [],
      objectGenerateDuplicate: {},
      isLoading: false,
      isClear: false,
      idProductFromSearch: "",
      productIndexFromSearch: null,
      productRefreshVersions: [],
      productStocks: [],
      cfopOptions: cfop,
    };
  },
  components: {
    AttachXmlFile,
    InputProducts,
    InputInfinit,
    InputSelect,
    ModalCreateProducts,
  },
  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_BILL"]),
    getCfopOptions(selectedCfop) {
      if (
        !selectedCfop ||
        this.cfopOptions.some((option) => option.value === selectedCfop)
      ) {
        return this.cfopOptions;
      }

      return [
        {
          value: selectedCfop,
          text: `${selectedCfop} - CFOP identificado no XML`,
        },
        ...this.cfopOptions,
      ];
    },
    async convertXml() {
      try {
        if (this.getXmlFile === null && !this.payloadFromDfe.xml) {
          this.$toast.open({
            message: "Selecione o arquivo XML!",
            type: "warning",
          });
          return null;
        }
        const FIVE_MB = 5 * 1024 * 1024;

        if (this.getXmlFile && this.getXmlFile.size > FIVE_MB) {
          this.$toast.open({
            message: "O arquivo XML excede o tamanho máximo permitido (5 MB).",
            type: "warning",
          });
          return null;
        }

        let xmlConvertedToString;
        if (this.payloadFromDfe.xml) {
          xmlConvertedToString = this.payloadFromDfe.xml;
        } else {
          xmlConvertedToString = await ConvertXml.xmlString(this.getXmlFile);
        }

        if (xmlConvertedToString === null) {
          this.$toast.open({
            message: "O arquivo deve ser um XML VALIDO",
            type: "error",
          });
          return null;
        } else {
          const { data } = await api.post(
            "/purchasenote",
            { xmlString: xmlConvertedToString },
            {
              maxContentLength: FIVE_MB,
              maxBodyLength: FIVE_MB,
            }
          );
          return data;
        }
      } catch (error) {
        console.log(error, "ocorreu um erro ao converter o arquivo XML");
      }
    },
    async converXmlAndReturnObjectAndSave() {
      try {
        this.isLoading = true;
        const xmlConverted = await this.convertXml();

        const data = ConvertXml.ObjectPurchase(xmlConverted);

        this.objectPurchaseTotal =
          AssigningValuesToTheObject.assigningValues(data);

        const prodGrid = removeReference(this.objectPurchaseTotal.products);

        this.originalProductTotals = prodGrid.map(
          (product) =>
            Number(product.valorUnitario) * Number(product.quantidade)
        );
        this.originalProductQuantities = prodGrid.map((product) =>
          Number(product.quantidade)
        );

        if (prodGrid.length) {
          for await (const prod of prodGrid) {
            const existsProd = await ServiceProducts.findByName(prod.nome);

            if (existsProd && existsProd.id) {
              prod.exists = true;
            } else {
              prod.exists = false;
            }
            prod.linked = false;
          }
        }

        this.originalXmlProducts = removeReference(prodGrid);
        this.productsListGrid = prodGrid;

        this.selectedPesticides = prodGrid.map((_, idx) => ({
          registro: null,
          id: null,
          idx,
          lote: null,
          idEmb: null,
          embalagem: null,
        }));
      } catch (error) {
        return this.$toast.open({
          message: "Ocorreu um erro ao listar os produtos!",
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async saveAllPurchase() {
      try {
        this.isLoading = true;
        if (!this.objectPurchaseTotal.purchase) return;

        const hasInvalidQuantity = this.productsListGrid.some(
          (product) => !this.isValidQuantity(product.quantidade)
        );

        if (hasInvalidQuantity) {
          return this.$toast.open({
            message: "Informe uma quantidade de estoque maior que zero.",
            type: "warning",
          });
        }

        const dataAllPurchase = {
          products: this.objectPurchaseTotal.products,
          supplier: this.objectPurchaseTotal?.supplier,
          purchase: this.objectPurchaseTotal?.purchase,
          key: this.objectPurchaseTotal?.key,
          valorNfe: this.objectPurchaseTotal.purchase.valorNfe,
          valorFrete: this.objectPurchaseTotal.purchase.valorFrete,
        };

        dataAllPurchase.purchase.cfop = this.cfopSelect;
        const { data } = await ServiceImportMovimentPurchase.save(
          dataAllPurchase
        );

        if (this.payloadFromDfe.fromDfe) {
          try {
            const mainfestPayload = {
              chNFe: dataAllPurchase.purchase.chaveNfe,
              tipoEvento: 210200, // "Confirmação da operação"
            };

            await ServiceDfe.updateSetSynced(dataAllPurchase.purchase.chaveNfe);
            await ServiceDfe.manifestDfe([mainfestPayload]);
            // eslint-disable-next-line no-empty
          } catch (error) {}
        }

        this.addDataBill(data, dataAllPurchase);

        this.$emit("dataProduct", dataAllPurchase.products);
        this.$emit("idSupplierForSelectBox", data.idProvider);
        this.$emit("modalIdForPurchase", data.idPurchase);
        this.$emit("valorNfe", dataAllPurchase.valorNfe);

        this.productsListGrid = [];

        this.$bvModal.show("modal-bill");
        this.$bvModal.hide("modalImportXml");

        return this.$toast.open({
          message: "Importado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      } finally {
        this.isLoading = false;
      }
    },

    async fillProductsComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(
          id,
          q,
          filterType,
          page,
          "normal"
        );
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async fillPesticidesComboBoxWithPaginate(
      id,
      q,
      filterType,
      page,
      typeProduct
    ) {
      try {
        const { data } = await ServiceCompendio.combobox(
          id,
          q,
          filterType,
          page,
          typeProduct
        );

        return data?.map((agro) => {
          return {
            id: agro.id,
            nome: agro.nomeComum,
            registro: agro.registro,
          };
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });

        return;
      }
    },

    async getProductsForSelectBox() {
      try {
        const products = await ServiceProducts.getProductsForSelectBox();
        this.productsForSelectBox = products.data.map((item) => {
          return {
            ...item,
            nome: `${item.nome} / ${item.embalagem || `Não informado`} / ${
              item.lote || `Não informado`
            }`,
            uuid: uuidv4(),
          };
        });
      } catch (error) {
        return this.$toast.open({
          message: "Ocorreu um erro ao listar os produtos!",
          type: "error",
        });
      }
    },

    async handleSelectItem(pesticide, idx) {
      if (!pesticide) return;

      this.listEmbs[idx] =
        await ServiceCompendio.findAllEmbalagensByIdAgrotoxico(pesticide.id);

      console.log(this.listEmbs[idx]);

      this.selectedPesticides[idx] = {
        registro: pesticide.registro,
        id: pesticide.id,
        nome: pesticide.nome,
        idx,
        lote: null,
        idEmb: null,
        embalagem: null,
      };

      this.$forceUpdate();
    },

    async handleSelectProduct(product, index) {
      if (!product?.id) {
        this.$set(this.productStocks, index, null);
        return;
      }

      const selectedProductId = product.id;
      const stock = await ServiceProducts.findStock(selectedProductId);

      if (this.idProductForSelectBox[index] === selectedProductId) {
        this.$set(this.productStocks, index, stock ?? 0);
      }
    },

    assingLote(lote, idx) {
      this.selectedPesticides[idx].lote = lote;
    },

    handleDisableLote(idx) {
      this.$nextTick(() => {});

      return this.selectedPesticides[idx]?.idEmb ? false : true;
    },

    changeTypeProduct(idx) {
      this.idProductForSelectBox[idx] = "";
      this.$set(this.productStocks, idx, null);

      this.selectedPesticides[idx] = {
        registro: null,
        id: null,
        idx,
        lote: null,
        idEmb: null,
        embalagem: null,
      };
    },

    isProductLinked(product) {
      return product.linked === true;
    },

    unlinkProduct(index) {
      const originalProduct = this.originalXmlProducts[index];
      const currentProduct = this.productsListGrid[index];

      if (!originalProduct || !currentProduct) return;

      const restoredProduct = {
        ...removeReference(originalProduct),
        quantidade: currentProduct.quantidade,
        estoque: currentProduct.estoque,
        valorUnitario: currentProduct.valorUnitario,
        cfop:
          this.objectPurchaseTotal.products[index]?.cfop ||
          currentProduct.cfop ||
          originalProduct.cfop,
        linked: false,
      };

      this.$set(
        this.objectPurchaseTotal.products,
        index,
        removeReference(restoredProduct)
      );
      this.$set(this.productsListGrid, index, restoredProduct);
      this.$set(this.idProductForSelectBox, index, "");
      this.$set(this.productStocks, index, null);
      this.$set(this.isAgrotoxico, index, "normal");
      this.$set(this.listEmbs, index, []);
      this.$set(this.selectedPesticides, index, {
        registro: null,
        id: null,
        idx: index,
        lote: null,
        idEmb: null,
        embalagem: null,
      });
      this.$set(
        this.productRefreshVersions,
        index,
        (this.productRefreshVersions[index] || 0) + 1
      );

      this.$toast.open({
        message: "Vínculo removido com sucesso!",
        type: "success",
      });
    },

    isValidQuantity(quantity) {
      return Number.isFinite(Number(quantity)) && Number(quantity) > 0;
    },

    getXmlQuantity(index) {
      return this.originalProductQuantities[index];
    },

    handleQuantityChange(quantity, index) {
      const convertedQuantity = Number(quantity);

      this.$set(this.productsListGrid[index], "quantidade", quantity);

      if (!this.isValidQuantity(convertedQuantity)) return;

      const originalTotal = this.originalProductTotals[index];
      const convertedUnitValue = Number(
        (originalTotal / convertedQuantity).toFixed(5)
      );

      this.$set(this.productsListGrid[index], "quantidade", convertedQuantity);
      this.$set(this.productsListGrid[index], "estoque", convertedQuantity);
      this.$set(
        this.productsListGrid[index],
        "valorUnitario",
        convertedUnitValue
      );

      this.$set(
        this.objectPurchaseTotal.products[index],
        "quantidade",
        convertedQuantity
      );
      this.$set(
        this.objectPurchaseTotal.products[index],
        "estoque",
        convertedQuantity
      );
      this.$set(
        this.objectPurchaseTotal.products[index],
        "valorUnitario",
        convertedUnitValue
      );
    },

    async assingProducts(productItem, index, idProduct) {
      try {
        let productToLink = null;

        if (this.isAgrotoxico[index] === "agrotoxico") {
          const currentPesticide = this.selectedPesticides[index];

          productToLink = await ServiceProducts.findPesticide(
            currentPesticide.id,
            currentPesticide.embalagem,
            currentPesticide.registro,
            currentPesticide.lote
          );

          if (!productToLink) {
            productToLink = {
              id: null,
              idAgrotoxico: currentPesticide.id,
              idEmbalagem: currentPesticide.idEmb,
              nome: currentPesticide.nome,
              lote: currentPesticide.lote,
              registroAgrotox: currentPesticide.registro,
              embalagem: currentPesticide.embalagem,
              tipoProduto: "agrotoxico",
            };
          }
        } else {
          productToLink = await ServiceProducts.getProductById(idProduct);
          if (!productToLink) {
            this.$toast.open({
              message: "Produto selecionado para vínculo não foi encontrado.",
              type: "error",
            });
            return;
          }
        }

        let linkedProduct = {
          ...productItem,
          id: productToLink.id,
          nome: productToLink.nome,
          codigo: productToLink.codigo,
          quantidade: productItem.quantidade,
          valorUnitario: productItem.valorUnitario,
          cfop: this.objectPurchaseTotal.products[index].cfop,
          exists: true,
          linked: true,
          tipoProduto: "normal",
          idAgrotoxico: null,
          idEmbalagem: null,
          embalagem: null,
          registro: null,
          lote: null,
        };

        if (this.isAgrotoxico[index] === "agrotoxico") {
          linkedProduct = {
            ...linkedProduct,
            idAgrotoxico: productToLink.idAgrotoxico,
            idEmbalagem: productToLink.idEmbalagem,
            registro: productToLink.registroAgrotox,
            embalagem: productToLink.embalagem,
            lote: productToLink.lote,
            tipoProduto: "agrotoxico",
          };
        }

        this.$set(this.objectPurchaseTotal.products, index, linkedProduct);
        this.$set(this.productsListGrid, index, linkedProduct);

        this.$toast.open({
          message: "Vínculo realizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.error("Erro ao vincular o produto:", error);
        this.$toast.open({
          message: "Ocorreu um erro ao tentar vincular o produto.",
          type: "error",
        });
      }
    },

    handleModalCreateProduct(nameModal, idProduct, index) {
      this.idProductFromSearch = idProduct;
      this.productIndexFromSearch = index;
      this.openModals(nameModal);
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    handleCreatedNewProduct() {
      if (this.productIndexFromSearch === null) return;

      const currentVersion =
        this.productRefreshVersions[this.productIndexFromSearch] || 0;

      this.$set(
        this.productRefreshVersions,
        this.productIndexFromSearch,
        currentVersion + 1
      );
    },

    addDataBill(data, dataAllPurchase) {
      this.objectGenerateDuplicate.valorTotal =
        dataAllPurchase.purchase.valorNfe;

      this.objectGenerateDuplicate.idFornecedor = data.idProvider;
      this.objectGenerateDuplicate.descricao = `Referente a nota de compra N°${dataAllPurchase.purchase.numeroNfe}`;
    },

    async generateDuplicate() {
      this.$toast.open({
        message: "Elaborado uma duplicata a partir de uma nota de compra!",
        type: "success",
      });

      this.SET_DATA_SEARCH_FROM_BILL(this.objectGenerateDuplicate);

      return this.$router.push({
        path: `/financeiro`,
      });
    },

    async handleSelectEmb(idEmb, idx) {
      if (this.isAgrotoxico[idx] !== "agrotoxico") return;

      const pesticideId = this.idProductForSelectBox[idx];

      const pesticide = await ServiceCompendio.findPesticideById(pesticideId);
      const registroAgrotox = pesticide?.registro || null;

      const embKey = this.listEmbs[idx].find(
        (emb) => emb.id === idEmb
      )?.descricao;

      await this.findLotes(pesticideId, embKey, registroAgrotox);

      this.selectedPesticides[idx].idEmb = idEmb;
      this.selectedPesticides[idx].embalagem = this.listEmbs[idx].find(
        (emb) => emb.id === idEmb
      )?.descricao;

      this.$forceUpdate();
    },

    async findLotes(idAgrotoxico, embalagem, registroAgrotox) {
      const result = await ServiceProducts.findLotes(
        idAgrotoxico,
        embalagem,
        registroAgrotox
      );

      this.dataLotes = result?.lotes || [];
    },

    cancel() {
      this.productsListGrid = [];
      this.objectPurchaseTotal = {};
      this.originalXmlProducts = [];
      this.originalProductTotals = [];
      this.originalProductQuantities = [];
      this.isClear = !this.isClear;
      this.idProductForSelectBox = [];
      this.isAgrotoxico = [];
    },

    goBack() {
      this.productsListGrid = [];
      this.objectPurchaseTotal = {};
      this.originalXmlProducts = [];
      this.originalProductTotals = [];
      this.originalProductQuantities = [];
      this.idProductForSelectBox = [];
    },
  },
  mounted() {
    this.getProductsForSelectBox();
    if (this.payloadFromDfe.xml) {
      this.$bvModal.show("modalImportXml");
      this.converXmlAndReturnObjectAndSave();
    }
  },
  computed: {
    productsLinkedIds() {
      return (
        this.objectPurchaseTotal.products?.map((p) => p.id).filter(Boolean) ||
        []
      );
    },
    getXmlFile() {
      if (this.$refs.attachedFile) return this.$refs.attachedFile.file[0];

      return null;
    },
    getMappedItems() {
      return (
        this.productsListGrid.filter((item) => item.linked === true)?.length ||
        0
      );
    },
  },
};
</script>

<style scoped>
.inputXml {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  font-size: 13px;
  text-align: center;
  background: #fffcfc;
}

.headerModal {
  font-size: 16px !important;
  font-weight: bold;
}

.spin {
  right: 5px;
  height: 20px;
  width: 20px;
  color: white;
}

.alertModal {
  font-size: 11px;
  color: rgb(115, 0, 0);
  padding-left: 40px;
}

.tableItems {
  width: 100%;
}

.tableItems thead {
  background-color: #c1c1c120;
  color: rgba(28, 28, 28, 0.764);
  border-bottom: solid 1px rgb(226 232 240 / 1);
}

.tableItems th {
  color: rgb(111, 111, 111);
  font-size: 9.5px;
  font-family: Poppins-Regular, sans-serif !important;
  padding: 10px 14px;
  font-weight: 600 !important;
}

.tableItems td {
  font-size: 11px;
  padding: 10px 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600 !important;
  border-bottom: solid 1px rgb(226 232 240 / 1);
}

.quantityColumn {
  min-width: 105px;
}

.cfopColumn {
  min-width: 145px;
}

.quantityInput {
  height: 30px;
  min-width: 85px;
  padding: 2px 8px;
  text-align: center;
  color: rgb(0 110 0);
  background-color: rgb(233 255 233);
  border-color: rgb(183 225 183);
  font-family: Poppins-Regular, sans-serif !important;
  font-size: 11px;
  font-weight: 600 !important;
}

.xmlQuantity {
  display: block;
  margin-top: 3px;
  text-align: center;
  color: rgb(111, 111, 111);
  font-size: 8.5px;
  font-weight: 500;
}

.tableItems tr:last-child td {
  border-bottom: none;
}

.tableProducts {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 30px 10px 10px 10px;
  width: 100%;
  font-size: 13px;
  height: 60vh;
  max-height: 60vh;
  overflow: scroll;
  text-align: center;
  background: #fffcfc;
}

.titleProducts {
  font-size: 16px;
  text-align: center;
  margin-bottom: 30px;
  cursor: context-menu;
}

.custom-file-label::after {
  background: red !important;
}

.headProducts {
  display: flex;
  border-bottom: 2px solid #d5d3d3;
  font-size: 12px;
  font-weight: bold;
}

.headProducts p {
  margin-bottom: 0rem !important;
}

.rowProducts p {
  margin-bottom: 0rem !important;
}

.rowProducts {
  display: flex;
  gap: 5px;
  height: 40px;
  border-bottom: 1px solid #f1efef;
  width: 100%;
  align-items: center;
}

.linkProduct {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 10px !important;
  font-family: Poppins-Medium, sans-serif !important;
  font-weight: 500 !important;
  background-color: #00786a;
  color: white;
  border-radius: 8px;
  border: none;
  gap: 10px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.259);
}

.linkProduct:hover {
  background: #006256;
  color: whitesmoke;
}

.unlinkProduct {
  font-size: 10px !important;
  font-family: Poppins-Medium, sans-serif !important;
  font-weight: 500 !important;
  background-color: #c23b3b;
  color: white;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.259);
}

.unlinkProduct:hover {
  background-color: #a32f2f;
  color: whitesmoke;
}

.linkXml {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #006256;
  border: none;
  color: white;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  gap: 10px;
  box-shadow: 0px 1px 1px 0px black;
}

.linkXml:hover {
  background: #002a40;
  color: whitesmoke;
}

.itemToggleDesc {
  position: relative;
  display: flex;
  width: 100%;
  height: 25px;
  margin-left: 0.65rem;
}

/* The slider */
.switch {
  height: 100%;
  margin: 0;
  font-size: 14px;
  position: relative;
  display: inline-block;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #d9d9d9;
  color: #ffffff;
  border-radius: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  transition: 0.4s;
  width: 60px !important;
  height: 100%;
  font-size: 8px;
}

.slider:before {
  position: absolute;
  content: "";
  font-size: 10px;
  height: 82%;
  width: 44%;
  left: 6%;
  border-radius: 50px;
  background-color: white;
  color: white;
  display: grid;
  align-content: center;
  justify-content: center;
  transition: 0.4s;
  font-weight: bold;
}

.slider:after {
  content: "";
  position: absolute;
  z-index: -1;
}

.switch input:checked + .slider {
  background-color: #00aa62;
  color: white;
}

.switch input:checked + .slider:before {
  content: "";
  background-color: white;
  transform: translateX(100%);
  color: white;
}

.switch input {
  display: none;
}

.contentIconHeader {
  min-width: 30px;
  min-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #00baa436 !important;
  border-radius: 8px;
}

.saveBtn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid green;
  color: green;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  box-shadow: 0px 1px 1px 0px black;
}

.saveBtn:hover {
  background: whitesmoke;
  border: 1px solid green;
  color: green;
}

.CancelBtn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: 1px solid red;
  color: red;
  border-radius: 3px;
  width: 180px;
  height: 28px;
  box-shadow: 0px 1px 1px 0px black;
}

.CancelBtn:hover {
  background: whitesmoke;
  border: 1px solid red;
  color: red;
}

.goBackBtn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: rgb(255, 255, 255);
  border: none;
  color: rgb(35, 35, 35);
  border-radius: 3px;
  width: 100px;
  height: 28px;
  transition: ease-in all 0.1s;
}

.goBackBtn:hover {
  background: whitesmoke;
  border: 1px solid gray;
  color: black;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.229);
  transition: ease-in all 0.1s;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.currentProductStock {
  position: absolute;
  top: -15px;
  right: 0;
  color: #3e66ae;
  font-size: 10px;
  white-space: nowrap;
}

.fixedSelect {
  position: absolute;
  font-size: 12px;
  bottom: 12px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}

.borderInput {
  font-size: 10px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.contentNot {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.alertImg {
  width: 100px;
  height: 100px;
}

.btnModal {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.content-btn {
  display: flex;
  align-items: center;
  justify-content: space-around !important;
  gap: 1rem;
}

.custom-select {
  padding: 0.375rem 0.25rem 0.375rem 0.75rem;
  line-height: 1.5;
  background: none;
}

.inputFile {
}

@media screen and (max-width: 700px) {
  .tableProducts {
    padding: 0px;
    font-size: 11px;
  }

  .headProducts {
    font-size: 11px;
  }
}
</style>
